module.exports = __webpack_public_path__ + "static/flags/GI-3885a63de62a2784e856571c3d4b0bf4.gif";